import HeroII from "./HeroII";
import compose from "recompose/compose";
import mapProps from "recompose/mapProps";
import defaultProps from "recompose/defaultProps";

const enhance = compose(
  defaultProps({
    contentColor: "almost-black",
  }),
  mapProps((props) => ({
    ...props.primary,
  }))
);

export default enhance(HeroII);
